import { get, post, put } from "../../config/api";

class StudioService {

    static async getRecipe(id) {
        const url = `/v3/dashboard/recipe/${id}`;
        return await get({ url });
    }

    static async getRecipes(data) {
        const url = "/v3/dashboard/recipe/paginated";
        return await post({ url, data })
    }

    static async createRecipe(data) {
        const url = "/v3/dashboard/recipe";
        return await post({ url, data })
    }

    static async getIngredients(data) {
        const url = "/v3/dashboard/ingredient/paginated";
        return await post({ url, data })
    }

    static async getIngredientData(id) {
        const url = `/v3/dashboard/ingredient/${id}`;
        return await get({ url });
    }

    static async createIngredient(data) {
        const url = `/v3/dashboard/ingredient`;
        return await post({ url, data })
    }

    static async updateIngredient(id, data) {
        const url = `/v3/dashboard/ingredient/${id}`;
        return await put({ url, data })
    }

    static async updateRecipe(id, data) {
        const url = `/v3/dashboard/recipe/${id}`;
        return await put({ url, data })
    }

    static async updateRecipeVerificationStatus(id, data) {
        const url = `/v3/dashboard/recipe/update/verified/${id}`;
        return await put({ url, data });
    }

}

export default StudioService;